import { FaIcon, faSaveSolid } from '@/lib/fa'
import React from 'react'

const TachoDiscFooter = ({
  onSave,
  isSaving = false,
  label = 'Zapisz',
  // Set when the disc can't be saved yet (e.g. no driver picked). Disables the
  // button and explains why, rather than letting the request fail server-side.
  disabledReason,
}: {
  onSave: () => void
  isSaving?: boolean
  label?: string
  disabledReason?: string | null
}) => {
  const disabled = isSaving || !!disabledReason
  return (
    <div className="tw-sticky tw-bottom-0 tw-z-[100] tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-4 tw-border-t tw-border-gray-300 tw-bg-white tw-p-4">
      {disabledReason && (
        <p className="tw-m-0 tw-mr-auto tw-text-sm tw-text-error">{disabledReason}</p>
      )}
      <button
        className={`tw-flex tw-items-center tw-gap-4 tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white ${
          disabled ? 'tw-cursor-not-allowed tw-opacity-60' : ''
        }`}
        onClick={onSave}
        disabled={disabled}
        title={disabledReason ?? ''}
      >
        <FaIcon icon={faSaveSolid} />
        <p>{isSaving ? 'Zapisywanie...' : label}</p>
      </button>
    </div>
  )
}

export default TachoDiscFooter
